

















import { defineComponent, PropType } from '@vue/composition-api';
import { Spacing } from '@front-app/components/constants';
import WarningCard from '@front-app/components/cards/state/WarningCard.vue';

export default defineComponent({
	components: { WarningCard },
	props: {
		errors: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup() {
		return {
			Spacing,
		};
	},
});
